// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"styles__wrapper___1Twmh","switch":"styles__switch___1QiRt","inside":"styles__inside___2jegB","active":"styles__active___24N6B","primary":"styles__primary___2TNM6","success":"styles__success___XNoV2","info":"styles__info___1Ks_e","warning":"styles__warning___1BDVZ","danger":"styles__danger___3OIL0","rotate":"styles__rotate___3_sDN","fadein":"styles__fadein___3mrQD","slideFromRight":"styles__slideFromRight___1mufv","waves":"styles__waves___2Bmly"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/SwitchFilters/styles.scss
// module id = ./resources/assets/js/components/SwitchFilters/styles.scss
// module chunks = 0